import { render, staticRenderFns } from "./GlobalModal.vue?vue&type=template&id=7641a61f&scoped=true"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"
import style0 from "./GlobalModal.vue?vue&type=style&index=0&id=7641a61f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7641a61f",
  null
  
)

export default component.exports